 import React, { useState, useEffect } from 'react'
import ModuleStyling from "./Modal.module.scss"
import { ModalData } from "./ModalData"; 
import ReactDom from "react-dom";
import { grey } from '@mui/material/colors';
import logger from "utils/logger";
/** 
 *
 * @param {Object} props
 * @param {Boolean} props.showModal
 * @param {String=} props.title
 * @param {String=} props.modalType
 * @param {String=} props.secondaryLabel
 * @param {()=>void=} props.secondaryCallback
 * @param {String=} props.primaryLabel
 * @param {()=>void=} props.primaryCallback
 * @param {React.ReactNode} props.children  
 * @param {Boolean} props.disablePrimaryBtn
 * @param {()=>void=} props.backButtonCallback
 * @param {()=>void=} props.closeModal
 * @param {String=} props.primaryTestId
 * @param {String=} props.secondaryTestId
 * @param {String=} props.containerTestId
 */

const Modal = ({
  modalType = "info",
  backButtonCallback,
  showModal,
  closeModal,
  children,
  title,
  secondaryCallback,
  primaryCallback,
  secondaryLabel,
  primaryLabel,
  primaryTestId,
  secondaryTestId,
  containerTestId,
  disablePrimaryBtn,
  subTitle,
  showDisabledPrimaryBtn=false,
  showPrimaryArrow = false,
  icon
}) => {
  const closeIcon = "/assets/img/modalIcons/closeIcon.svg";
  const logoutIcon = "/assets/img/modalIcons/logoutIcon.svg";
  const shieldIcon = "/assets/img/modalIcons/shieldIcon.svg";
  const arrowIcon = "/assets/img/modalIcons/arrows.svg";

  // Fallback to 'info' if modalType not found in ModalData
  const modalData = ModalData[modalType] || ModalData["info"];
  
  if (!ModalData[modalType]) {
    logger.warn(`Modal type "${modalType}" not found in ModalData. Using "info" as fallback.`);
  }

  const isSignout = modalType == "signout";
  const isDiscard = modalType == "discard";
  const smallMobileStylingData = modalData.customSize.smallMobile;
  const mobileStylingData = modalData.customSize.mobile;
  const tabletStylingData = modalData.customSize.tablet;  
  const desktopStylingData = modalData.customSize.desktop;
  const customLayout = modalType === "action" || modalType === "step"
  const customMissingDocLayout = modalType === "missingDocNotifModal"
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  
  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
      // logger.log("screenWidth", window.innerWidth);
    };
    window.addEventListener('resize', handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };

  }, []);

  return ReactDom.createPortal(
    <>
      {showModal && <div className={ModuleStyling.OuterModalContainer} data-testid={containerTestId}>
        <div 
          className={ModuleStyling.MainContainer}
          style={{ 
            borderRadius: 20,
            maxWidth: modalType === "action" ? "650px" : modalType=== "step" && 500, 
            maxHeight:  modalType === "action" ? "95vh" : modalType=== "step" && "85vh", 
            display: customLayout && "grid", 
            height: customLayout && "100%", 
            "--containerHeight": `${ 
              screenWidth > tabletStylingData.breakpoint ? desktopStylingData.customHeight.height :
              screenWidth < tabletStylingData.breakpoint && screenWidth >= mobileStylingData.breakpoint ? tabletStylingData.customHeight.height :
              screenWidth < mobileStylingData.breakpoint && mobileStylingData.customHeight.height 
            }`, 
            "--containerMaxHeight": `${ 
              subTitle ? "95svh" : 
              screenWidth > tabletStylingData.breakpoint ? desktopStylingData.customHeight.maxHeight :
              screenWidth < tabletStylingData.breakpoint && screenWidth >= mobileStylingData.breakpoint ? tabletStylingData.customHeight.maxHeight :
              screenWidth < mobileStylingData.breakpoint && mobileStylingData.customHeight.maxHeight 
            }`, 
            "--containerMinHeight": `${ 
              screenWidth > tabletStylingData.breakpoint ? desktopStylingData.customHeight.minHeight :
              screenWidth < tabletStylingData.breakpoint && screenWidth >= mobileStylingData.breakpoint ? tabletStylingData.customHeight.minHeight :
              screenWidth < mobileStylingData.breakpoint && mobileStylingData.customHeight.minHeight 
            }`, 
            "--containerWidth": `${ 
              screenWidth > tabletStylingData.breakpoint ? desktopStylingData.customWidth.width :
              screenWidth < tabletStylingData.breakpoint && screenWidth >= mobileStylingData.breakpoint ? tabletStylingData.customWidth.width :
              screenWidth < mobileStylingData.breakpoint && mobileStylingData.customWidth.width 
            }`, 
            "--containerMaxWidth": `${ 
              screenWidth > tabletStylingData.breakpoint ? desktopStylingData.customWidth.maxWidth :
              screenWidth < tabletStylingData.breakpoint && screenWidth >= mobileStylingData.breakpoint ? tabletStylingData.customWidth.maxWidth :
              screenWidth < mobileStylingData.breakpoint && mobileStylingData.customWidth.maxWidth 
            }`,  
            "--containerMinWidth": `${ 
              screenWidth > tabletStylingData.breakpoint ? desktopStylingData.customWidth.minWidth :
              screenWidth < tabletStylingData.breakpoint && screenWidth >= mobileStylingData.breakpoint ? tabletStylingData.customWidth.minWidth :
              screenWidth < mobileStylingData.breakpoint && mobileStylingData.customWidth.minWidth 
            }`,  
            "--containerGridRowsTemplate": `${
              modalType === "refund" ? "140px 1fr 150px" :
              (customLayout && screenWidth > tabletStylingData.breakpoint) ? "160px calc(100% - 240px) 80px" :
              (customLayout && (screenWidth < smallMobileStylingData.breakpoint  || screenWidth < smallMobileStylingData.breakpoint || screenWidth < tabletStylingData.breakpoint)) ? "160px calc(100% - 300px) 150px" :
              (subTitle && !customMissingDocLayout && screenWidth > tabletStylingData.breakpoint )? "235px 250px 80px" :
              (subTitle && !customMissingDocLayout && (screenWidth < smallMobileStylingData.breakpoint  || screenWidth < smallMobileStylingData.breakpoint || screenWidth < tabletStylingData.breakpoint) )? "235px 250px 150px" :
              screenWidth > tabletStylingData.breakpoint ? desktopStylingData.gridLayout :
              screenWidth < tabletStylingData.breakpoint && screenWidth >= mobileStylingData.breakpoint ? tabletStylingData.gridLayout :
              screenWidth < mobileStylingData.breakpoint && screenWidth >= smallMobileStylingData.breakpoint ? mobileStylingData.gridLayout :
              screenWidth < smallMobileStylingData.breakpoint && smallMobileStylingData.gridLayout 
            }`
          }}
          > 
          <div className={ModuleStyling.HeaderContainer}>
            {closeModal ? <div 
              className={ModuleStyling.closeIcon} 
              onClick={() =>{ closeModal() }}
            >
              <img src={closeIcon}/>
            </div> : <></>}
            {typeof backButtonCallback === "function" && <div className={ModuleStyling.backButton}>
              <button onClick={backButtonCallback}>
                {"< back"}
              </button>
            </div>}
            <div 
              className={ModuleStyling[ (modalData.HeaderStyle === "" || modalData.HeaderStyle === undefined) ? "defaultHeader" : modalData.HeaderStyle ]}
              style={{ padding: '1rem' }}
            >
              {(icon || modalData.header.image) ? <img style={{marginTop: subTitle && 0}} src={icon || modalData.header.image}/> : ""}
              <div style={{margin: subTitle && 10}} className={`${ModuleStyling.title} `}>
                {title}
              </div>
              {subTitle && <span className={ModuleStyling.subTitle}>{subTitle}</span>}
            </div>
          </div>
          <div className={ModuleStyling.contentContainer}>
            <div className={ModuleStyling[ (modalData.ContentStyle === "" || modalData.ContentStyle === undefined) ? "defaultContent" : modalData.ContentStyle ]}>
              {children}
            </div> 
          </div>
          <div style={{marginTop: customLayout && "0px"}} className={ModuleStyling.FooterContainer} > 
            <div className={ModuleStyling[ (modalData.FooterStyle === "" || modalData.FooterStyle === undefined) ? "defaultFooter" : modalData.FooterStyle ]}>
              {secondaryLabel && ( 
                <button 
                  className={`button-v2 ${(disablePrimaryBtn && !showDisabledPrimaryBtn) ? "primary-theme-btn" : (isSignout || isDiscard || subTitle) ? "logout-theme-btn" : "text-theme-btn"}`}   
                  onClick={secondaryCallback}
                  data-testid={secondaryTestId}
                  style={{ 
                    border: '3px solid #d1d5db', 
                    borderRadius: 10, 
                    width: '100%',
                    textDecoration: 'none',
                    color: grey[700]
                  }}
                >{secondaryLabel || "Cancel"}</button>
              )}
              {(!disablePrimaryBtn || showDisabledPrimaryBtn) && primaryLabel && ( 
                <button 
                  className={"button-v2 primary-theme-btn"}  
                  disabled={disablePrimaryBtn === undefined ? false : disablePrimaryBtn}
                  onClick={primaryCallback}
                  data-testid={primaryTestId}
                  style={{ borderRadius: 10, width: '100%', color: '#fff' }}
                >
                  {primaryLabel}
                  {(showPrimaryArrow || isSignout || subTitle) && (
                    <img style={{marginLeft: 5}} src={isSignout ? logoutIcon : arrowIcon}/>
                  )}  
                </button>
              )}
            </div>
            
          </div> 
          { isSignout &&
            (<div style={{display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#f5f7fa", padding: 20, borderRadius: "0 0 20px 20px", fontSize: 12, color: "#414141", gap: 10}}>
              <span><img src={shieldIcon} alt="" /></span>
              <span>Secure logout processing</span>
            </div>)
          }
        </div>
      </div>}
    </>
    , document.body)
}

export default Modal